import React, { useRef, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    Grid
} from '@material-ui/core';
import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';

// Componente per una riga di campi (3 colonne)
const FieldRow = ({ fields }) => (
    <Grid container spacing={2} style={{ marginBottom: 8 }}>
        {fields.map(({ label, value }, index) => (
            <Grid item xs={12} sm={4} key={index}>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{label}</Typography>
                <Typography variant="body2">{value ?? '-'}</Typography>
            </Grid>
        ))}
    </Grid>
);

// Componente per una sezione con titolo e righe di campi
const Section = ({ title, rows }) => (
    <Paper style={{ padding: 16, marginBottom: 24 }}>
        <Typography variant="h6" style={{ marginBottom: 16 }}>{title}</Typography>
        {rows.map((fields, index) => (
            <FieldRow key={index} fields={fields} />
        ))}
    </Paper>
);

const PodContendibilita = () => {
    // Dentro il componente
const isMountedRef = useRef(true); // serve per evitare memory leak su componenti smontati
const [loading, setLoading] = useState(false);
    const [codicePod, setCodicePod] = useState('');
    const [matricolaContatore, setMatricolaContatore] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [responseData, setResponseData] = useState(null);


    const validateForm = () => {
        setErrorMessage('');

        if (!codicePod && !matricolaContatore) {
            setErrorMessage('Per la verifica inserire campo codice POD o matricola del contatore');
            return false;
        }

        if (codicePod) {
            const trimmedPod = codicePod.trim();

            if (trimmedPod.length < 14) {
                setErrorMessage('Il codice POD deve avere almeno 14 caratteri');
                return false;
            }

            if (trimmedPod.length > 15) {
                setErrorMessage('Il codice POD non può superare i 15 caratteri');
                return false;
            }

            if (!trimmedPod.startsWith('IT')) {
                setErrorMessage('Il codice POD deve iniziare con "IT"');
                return false;
            }

            if (!/^[A-Z0-9]+$/.test(trimmedPod)) {
                setErrorMessage('Il codice POD può contenere solo lettere maiuscole e numeri');
                return false;
            }

            if (!/\d/.test(trimmedPod)) {
                setErrorMessage('Il codice POD deve contenere almeno un numero');
                return false;
            }
        }

        return true;
    };


    // Gestione submit
    const handleSubmit = (e) => {
        e.preventDefault();

        // Reset dati e messaggi ad ogni submit
        setResponseData(null);
        setErrorMessage('');

        if (!validateForm()) return;

        setLoading(true);

        const payload = {
            codicePOD: codicePod,
            matricolaContatore: matricolaContatore
        };

        console.log('RICHIESTA______xxxx');

        axios
  .post(URLS.CONTENDIBILITA_SII, payload)
  .then(response => {
    setResponseData(response.data);
  })
  .catch(err => {
    setErrorMessage(err.response?.data?.message || 'Errore nella richiesta');
  })
  .finally(() => setLoading(false));



    };

/*
    const handleSubmit = (e) => {
        e.preventDefault();

        // Pulisce i dati precedenti
        setResponseData(null);


        if (!validateForm()) return;

        // Simulazione della risposta
        setResponseData({
            ammissibilita: false,
            ammissibilitaStr: 'Negativo',
            ammissibilitaCodice: 'KO',
            ammissibilitaMotivazione: 'Codice POD non valido',

            /*
            ammissibilita: true,
            ammissibilitaStr: 'Positivo',
            ammissibilitaCodice: 'OK',
            ammissibilitaMotivazione: 'Richiesta valida',
            //DATI POD
            codicePod: codicePod,
            pIvaDistributore: '12345678901',
            podAttivoStr: 'Attivo',
            //ESITO RICHIESTA
            nuovaAttivazione: 'NO',
            contendibile: 'SI',
            attivazioneSII: 'ND',
            //DATI TECNICI
            tensione: 'BT',
            tipoMisuratore: 'Elettronico',

            //DATI FORNITURA
            toponimo: 'STRADA',
            via: 'FONTANA DI POLO',
            civico: '38',
            cap: '05100',
            istat: '055032',
            localita: 'TERNI',
            provincia: 'TR',
            nazione: 'ITALIA'
            
        });
    };**/


    return (
        <Box maxWidth={900} mx="auto" mt={4}>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Codice POD"
                    value={codicePod}
                    onChange={(e) => setCodicePod(e.target.value.toUpperCase())}
                    fullWidth
                    margin="normal"
                />

                <TextField
                    label="Matricola Contatore"
                    value={matricolaContatore}
                    onChange={(e) => setMatricolaContatore(e.target.value)}
                    fullWidth
                    margin="normal"
                />

                <Box mt={4}>
                    <Button variant="contained" color="primary" type="submit" disabled={loading}>
                        {loading ? 'Verifica in corso...' : 'Verifica'}
                    </Button>
                </Box>
                {/* Spazio extra prima della sezione */}
                <Box mt={4} />
            </form>

            {/* Messaggio di errore del form */}
{errorMessage && (
    <Box 
        mt={4} 
        p={2} 
        bgcolor="#fdecea" 
        border="1px solid #f44336" 
        borderRadius={4}
    >
        <Typography color="error" variant="h6">
            RICHIESTA NON AMMISSIBILE :
        </Typography>
        <Typography color="error" variant="body1">
            {errorMessage}
        </Typography>
    </Box>
)}

            {responseData && responseData.ammissibilita !== undefined && (
                <>
                    {responseData.ammissibilita ? (
                        <>
                            <Section
                                title="DATI POD"
                                rows={[
                                    [
                                        { label: 'Codice POD', value: responseData?.codicePod },
                                        { label: 'Distributore', value: responseData?.pIvaDistributore },
                                        { label: 'Stato POD', value: responseData?.podAttivoStr },
                                    ],
                                ]}
                            />

                            <Section
                                title="ESITO RICHIESTA"
                                rows={[
                                    [
                                        { label: 'Nuova attivazione', value: responseData?.nuovaAttivazione?.toString() },
                                        { label: 'Contendibile', value: responseData?.contendibile?.toString() },
                                        { label: 'Attivazione SII', value: responseData?.attivazioneSII?.toString() },
                                    ],
                                ]}
                            />

                            <Section
                                title="DATI TECNICI"
                                rows={[
                                    [
                                        { label: 'Matricola Attiva', value: responseData?.matricolaEnergiaAttiva },
                                        { label: 'Matricola Reattiva', value: responseData?.matricolaEnergiaReattiva },
                                        { label: 'Matricola Potenza', value: responseData?.matricolaPotenza },
                                        { label: 'Potenza Impegnata', value: responseData?.potenzaImpegnataContrattuale },
                                        { label: 'Potenza Disponibile', value: responseData?.potenzaDisponibile },
                                        { label: 'Tensione', value: responseData?.tensione },
                                        { label: 'Tipo misuratore', value: responseData?.tipoMisuratore },
                                        //{ label: 'Altro campo', value: '-' }, // placeholder per colonna vuota
                                    ],
                                ]}
                            />

                            <Section
                                title="DATI FORNITURA"
                                rows={[
                                    [
                                        { label: 'Toponimo', value: responseData?.toponimo },
                                        { label: 'Indirizzo', value: responseData?.via },
                                        { label: 'Civico', value: responseData?.civico },
                                        { label: 'CAP', value: responseData?.cap },
                                        { label: 'ISTAT', value: responseData?.istat },
                                        { label: 'Localita', value: responseData?.localita },
                                        { label: 'Provincia', value: responseData?.provincia },
                                        { label: 'Nazione', value: responseData?.nazione },
                                        { label: 'Altro', value: responseData?.altro },
                                    ],
                                ]}
                            />
                        </>
                    ) : (
                        <Box 
                            mt={4} 
                            p={2} 
                            bgcolor="#fdecea" 
                            border="1px solid #f44336" 
                            borderRadius={4}
                        >
                            <Typography color="error" variant="h6">
                                RICHIESTA NON AMMISSIBILE :
                            </Typography>
                            <Typography color="error" variant="body1">
                                {responseData.ammissibilitaMotivazione} [{responseData.ammissibilitaCodice}]
                            </Typography>
                        </Box>

                        
                    )}
                </>
            )}
        </Box>
    );
};

export default PodContendibilita;
